import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {AccountSearchModel} from "../account-search.model";
import {AccountSearchPageComponent} from "../account-search-page/account-search-page.component";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-account-single-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/single-select-search-control.component.html",
    providers: [
        provideSearchModel(AccountSearchModel),
        registerSearchControl(AccountSingleSelectSearchControlComponent)
    ]
})

export class AccountSingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<AccountSearchModel> {
    constructor(model: AccountSearchModel, injector: Injector) {
        super(model, injector, "accountId", "accountName");
        this.extendedSearchComponent = AccountSearchPageComponent;
    }
}
